/** An employee's seniority level, translated for display; empty when unknown. */
export const getLevelLabel = (
  level: string | null,
  t: (key: string) => string
): string => {
  switch (level) {
    case "FOUNDER":
      return t("components.dataTableCompanyEmployees.levels.founder");
    case "DIRECTION":
      return t("components.dataTableCompanyEmployees.levels.direction");
    case "MANAGER":
      return t("components.dataTableCompanyEmployees.levels.manager");
    case "DEFAULT":
      return t("components.dataTableCompanyEmployees.levels.employee");
    default:
      return "";
  }
};

/** Where a seniority level sorts: founders first, unknown levels last. */
export const getLevelOrder = (level: string): number => {
  switch (level) {
    case "FOUNDER":
      return 0;
    case "DIRECTION":
      return 1;
    case "MANAGER":
      return 2;
    case "DEFAULT":
      return 3;
    default:
      return 3;
  }
};
